import { assertNever } from '@varos/util-typescript';
import { ChatControllerBaseConfig } from '../../../base';
import { CallRequestUpsertController } from './callRequestUpsertInterface';
import {
    CallRequestUpsertControllerProps,
    CallRequestUpsertViewProps,
} from './callRequestUpsertProps';
import { FiPhone, FiPhoneOff } from 'react-icons/fi';

export function createCallRequestUpsertController(
    config: ChatControllerBaseConfig
): CallRequestUpsertController {
    return {
        useProps(context, item, props): CallRequestUpsertViewProps {
            if (props.context.value === null) {
                return {
                    status: {
                        kind: 'calling',
                        component: {
                            integration: item.integration,
                            thread: item.thread.thread,
                            onContext(context) {
                                props.context.onChange(context);
                            },
                        },
                    },
                };
            }
            return {
                status: {
                    kind: 'ready',
                    component: {
                        item: {
                            integration: item.integration,
                            definition: item.definition,
                            thread: item.thread,
                            context: {
                                context: props.context.value,
                                // TODO propagate solution and config to call
                                solution: null,
                                config: null,
                            },
                        },
                        onEnd(call) {
                            return props.onEnd(call);
                        },
                    },
                },
            };
        },
    };
}
